<template>
  <Modal v-model="modal" :title="title" width="700">
    <Form ref="form" :model="form" :rules="rule" :label-width="100">
      <FormItem :label="$t('name.template.image')" prop="img">
        <Upload v-model="form.image" />
      </FormItem>
      <FormItem :label="$t('name.template.name')" prop="name">
        <Input v-model="form.name" />
      </FormItem>
      <FormItem :label="$t('name.template.keyword')" prop="keyword">
        <Input v-model="form.keyword" />
      </FormItem>
      <FormItem :label="$t('name.template.version')" prop="sort">
        <Input v-model="form.version" />
      </FormItem>
      <FormItem :label="$t('name.template.sort')" prop="sort">
        <InputNumber v-model="form.sort" />
      </FormItem>
      <FormItem :label="$t('name.template.html')" prop="html">
        <Input v-model="form.html" type="textarea" :rows="18" />
      </FormItem>
      <FormItem :label="$t('name.template.data')" prop="data">
        <Input v-model="form.data" type="textarea" :rows="10" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" :loading="loading" @click="onPost">{{ title }}</Button>
    </div>
  </Modal>
</template>
<script>
import { put } from '@/api/template'
import Upload from '@/main/components/upload'

export default {
  components: {
    Upload
  },
  computed: {
    title() {
      return this.form.id ? this.$t('name.update') : this.$t('name.create') 
    }
  },
  data() {
    return {
      modal: false,
      loading: false,
      form: {},
      field: {
        name: '',
        img: '',
        url: '',
        sort: 0,
        language: ''
      },
      rule: {
        name: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        image: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        version: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        keyword: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        sort: [
          { required: true, type: 'number', message: ' ', trigger: 'blur' }
        ],
        html: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        data: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    open(data) {
      this.modal = true

      if(!data) {
        // 初始化字段
        data = Object.assign({}, this.field)
      }
      // 深拷贝
      this.form = Object.assign({}, data)

      // 清空验证
      this.$refs.form.resetFields()
    },
    close() {
      this.modal = false
    },
    onPost() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          put(this.form).then(res => {
            this.close()
            this.loading = false
            this.$Message.success(this.$t('message.' + res.message))
            this.$emit('get')
          }).catch(res => {
            this.loading = false
            this.$Message.error(this.$t('message.error.' + res.message))
          })
        }
      })
    }
  }
}
</script>